import { useEffect, useState } from 'react';
import { getUserCountry, strings } from '../../../shared';
import { Section } from './Section';
import { euCountries } from '../../../shared/utils/eu-countries';

export const SectionEURawlogPause = () => {
  const country = getUserCountry();
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  useEffect(() => {
    if (euCountries.includes(country?.toLowerCase())) setShowDisclaimer(true);
    else setShowDisclaimer(false);
  }, [country]);

  if (!showDisclaimer) {
    return <></>;
  }

  return (
    <Section>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '180px',
          marginBottom: '2rem',
        }}
      >
        <div
          className="card w-100 d-flex align-items-center bg-light my-4"
          style={{ border: 'medium solid #6d7074', fontSize: '1.1rem' }}
        >
          <div className="card-body text-center w-75">
            <p>{strings.rawlog_pause.existing_account_description}</p>
            <p>{strings.rawlog_pause.cta}</p>
          </div>
        </div>
      </div>
    </Section>
  );
};
